// buildAiSessionAutoTitle.js — Recents title from first prompt / entity

import {
  AI_LEGACY_FEED_TITLES,
  AI_NEW_CHAT_TITLE,
  AI_TITLE,
  AI_UPDATES_TITLE,
} from 'spaces/constants/aiConstants';

const DEFAULT_MAX = 48;

function cleanString(value) {
  return String(value || '').trim();
}

function collapseWhitespace(value) {
  return cleanString(value).replace(/\s+/g, ' ');
}

export function truncateAiSessionTitle(value, max = DEFAULT_MAX) {
  const text = collapseWhitespace(value);
  if (!text) return '';
  if (text.length <= max) return text;
  const slice = text.slice(0, Math.max(1, max - 1)).trim();
  return `${slice}…`;
}

/**
 * Prefer a resolved record title; else cleaned / truncated question.
 * @returns {string} Non-empty display title
 */
export function buildAiSessionAutoTitle({
  question = '',
  entityTitle = '',
  maxLength = DEFAULT_MAX,
} = {}) {
  const fromEntity = truncateAiSessionTitle(entityTitle, maxLength);
  if (fromEntity) return fromEntity;

  const fromQuestion = truncateAiSessionTitle(question, maxLength);
  if (fromQuestion) return fromQuestion;

  return AI_NEW_CHAT_TITLE;
}

export function shouldApplyAiAutoTitle(channel) {
  const sessionKind = cleanString(channel?.sessionKind);
  if (sessionKind === 'feed') return false;

  const source = cleanString(channel?.titleSource);
  if (source === 'user') return false;

  // Legacy / Feed inbox docs should not be auto-titled from user prompts.
  const title = cleanString(channel?.title);
  const titleLower = title.toLowerCase();
  if (
    !sessionKind
    && (
      !title
      || title === AI_TITLE
      || title === AI_UPDATES_TITLE
      || AI_LEGACY_FEED_TITLES.includes(titleLower)
    )
  ) {
    return false;
  }

  if (!title) return true;
  if (title === AI_NEW_CHAT_TITLE) return true;
  if (title === AI_TITLE && sessionKind === 'chat') return true;
  return source === 'system' || source === 'auto' || !source;
}
